import { useSuspenseQuery, useQueryClient } from '@tanstack/react-query';
import queryKeys from '../../support/uiStateKeys';

const dataKey = queryKeys.SELECTED_ULTRA_PACK;
export const defaultSelectedPack = 5;

const useSelectedUltraPack = () => {
  const queryClient = useQueryClient();

  const { data } = useSuspenseQuery<number | null>({
    queryKey: [dataKey],
    queryFn: ({ queryKey }) =>
      queryClient.getQueryData<number | null>(queryKey) ?? null,
    initialData: defaultSelectedPack,
  });

  const setSelectedUltraPack = (selectedPack: number | null) => {
    queryClient.setQueryData([dataKey], selectedPack);
  };

  return {
    selectedUltraPack: data,
    setSelectedUltraPack,
  };
};

export default useSelectedUltraPack;
